import { __rest } from "tslib";
import React, { useCallback, useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Checkbox } from '../checkbox/checkbox';
import { useDropdown } from '../dropdown';
import { context } from './utils';
import s from './select.module.css';
import { handleKeyPressEnter } from '../../utils/handle-keypress-enter';
import { getStringFromReactNode } from '../../utils/get-string-from-react-node';
const Option = ({ value, children, checkbox = true, disabled = false, divider = false, dataTest, selected = false, }) => {
    const { toggle } = useDropdown();
    const { mode, onChange, dataTest: contextDataTest } = useContext(context);
    const [check, setCheck] = useState(selected);
    const handleClick = useCallback(event => {
        const update = mode === 'standalone' ? false : !check;
        setCheck(update);
        onChange(value, update, event);
        if (mode !== 'multiple') {
            toggle();
        }
    }, [value, mode, toggle, onChange, check]);
    useEffect(() => setCheck(selected), [selected]);
    const attrs = Object.assign(Object.assign(Object.assign({ 'data-option': '' }, {
        'data-test': dataTest
            ? dataTest
            : contextDataTest
                ? `${contextDataTest}-option:${value}`
                : `option:${value}`,
    }), (check && { 'data-selected': '' })), (disabled
        ? { 'data-disabled': '' }
        : {
            onClick: handleClick,
            onKeyPress: handleKeyPressEnter(handleClick),
            role: 'button',
            tabIndex: 0,
        }));
    return (React.createElement("div", Object.assign({ className: classNames(s.option, divider && s.divider, mode === 'multiple' && s.multiple) }, attrs),
        mode === 'multiple' && checkbox && (React.createElement("div", { className: s.checkbox },
            React.createElement(Checkbox, { value: check, disabled: disabled }))),
        React.createElement("div", { className: s.content }, children)));
};
const NativeOption = ({ value, children, selected, disabled, dataTest, }) => {
    const { setNativeValue } = useContext(context);
    useEffect(() => {
        if (selected) {
            setNativeValue(value);
        }
    }, [setNativeValue, value, selected]);
    return (React.createElement("option", Object.assign({ value: value, disabled: disabled, "data-test": dataTest }, (typeof value === 'number' && { 'data-int': '' })), getStringFromReactNode(children)));
};
const SelectOption = (_a) => {
    var props = __rest(_a, []);
    const { native } = useContext(context);
    return native ? React.createElement(NativeOption, Object.assign({}, props)) : React.createElement(Option, Object.assign({}, props));
};
export default SelectOption;
//# sourceMappingURL=option.js.map